<template>
<div id="app">
    <div>
      <AppBar id="appBar"></AppBar>
      <router-view  style=""></router-view>
      <!--Footer v-if="isMainPage" id="footer"></Footer-->
      <ShortFooter v-if="isMainPage" id="footer"></ShortFooter>
    </div>
</div>
</template>
<style type="text/css">
.md-dialog-container {
  transform: none !important;
  min-width: 50% !important;;
}
#app {
  position: relative;
  width: 100vw;
  /*height: 100vh;*/
  max-width:100%;
  overflow-x: hidden;
}
</style>
<script>
import AppBar from '@/components/App/AppBar'
import Footer from '@/components/Footer/Footer'
import ShortFooter from '@/components/Footer/ShortFooter'
export default {
  components: {
    AppBar, Footer, ShortFooter
  },
  data () {
    return {
      windowWidth: 0
    }
  },
  created () {
    window.addEventListener('resize', this.handleResize)
    this.screenWidth()
  },
  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },
  computed: {
    isLogin () {
      console.log(this.$store.getters.isLoggedIn)
      return this.$store.getters.isLoggedIn
      // return this.$
    },
    isMainPage () {
      // return this.$route.matched.some(route => route.name === 'Login')
      return !this.$route.matched.some(route => route.meta.requiresAuth)
    },
    screenWidth () {
      return () => {
        if (window.innerWidth > 1024) {
          return 'desktop'
        } else if (window.innerWidth > 760) {
          return 'tablet'
        } else {
          return 'mobile'
        }
      }
    }
  }

}
</script>
